export default __webpack_public_path__ + "static/media/Maths_tutoringSmall.740a9472.jpg";